import Component from "vue-class-component";
import cloneDeep from "lodash/cloneDeep";
import VueDraggableResizable from "vue-draggable-resizable";
import style from "./style.vue";
import DialogFactory from "@/views/components/picker/dialogFactory";
import IPSDialog from "@/views/components/picker/dialog";
import LinkForm from "@/views/components/linkForm/linkForm.vue";
import { QinggerLibUtils, noop } from "@/util";
import { IPSService } from "@/services/ipsServices";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
const isset = QinggerLibUtils.isset;

@DialogFactory
@Component({
	components: {
		LinkForm,
		VueDraggableResizable,
	},
	mixins: [style],
})
export default class AddHotDialog extends IPSDialog {
	// 传递的参数
	img = "https://ssl-picture.tenyun.runsasoft.com/d1f3a8e0-de09-11ea-9bb5-a1ce76186005";
	treeSelect = {};
	state = 1;
	form: ItemObject = {};
	// 内部参数
	title = "热区编辑器";

	confirm = true;

	// readonly = true;

	width = "800px";

	hotList = [];

	openCoupon = 0;

	empCode = "";
	scroll = false;

	$refs: Record<string, any>;

	newHotItem = {
		linkType: null,
		linkId: "",
		linkDesc: "",
		hotPosition: {
			x: 10,
			y: 10,
			height: 50,
			width: 50,
		},
		eventListener: null,
		resize: null,
		_active: false,
		siteCodes: [],
		productSort: null,
		shareImage: "",
		shareInfo: "",
	};

	selectType = null;

	linkId = null;

	hotArray = [];

	hotActiveIndex = -1;

	sort = 0;

	// 关联分类列表
	attributeList = [];

	// 运营模式 1 镜单  2 镜千 3 云单 4 云千
	mode = 1;

	siteId = 0;

	exclude = [7, 14, 15, 16];
	targetHeight = 0;

	onResize(x, y, width, height, i) {
		this.hotArray[i].linkValue.hotPosition.x = x;
		this.hotArray[i].linkValue.hotPosition.y = y;
		this.hotArray[i].linkValue.hotPosition.width = width;
		this.hotArray[i].linkValue.hotPosition.height = height;
	}

	onDrag(x, y, i) {
		this.hotArray[i].linkValue.hotPosition.x = x;
		this.hotArray[i].linkValue.hotPosition.y = y;
	}

	async onLoad(el) {
		// 俊哥说暂时去掉
		this.mode === 2 && this.exclude.push(8);
		!this.openCoupon && this.exclude.push(12);

		this.attributeList = await this.getAttributeList();
		this.confirm = this.state === 1;
		const mh = document.querySelectorAll(".upLoadedPic")[0].clientHeight;
		this.targetHeight = mh;
		this.newHotItem.siteCodes = this.form.siteCodes || [];

		this.hotArray = this.hotList.map((item, index) => {
			item = { ...cloneDeep(this.newHotItem), ...item };
			item.linkValue = { ...cloneDeep(this.newHotItem), ...item };
			item.ref = `hot${index}`;

			// 赋值链接至
			item.form = { ...cloneDeep(this.form), ...item };
			return item;
		});
		this.sort = this.hotArray.length;
	}

	getDisabledClose(i) {
		let result = this.state === 1;
		if (this.hotArray[i].linkValue.linkType === 12 && this.form.advId) {
			result = false;
		}
		return result;
	}

	results() {
		const result = this.hotArray.map((i) => {
			const jumpPath = i.linkValue.jumpPath || { appName: "", pagePath: "" };
			const couponInfo = i.linkValue.couponInfo || { cplId: "", couponCover: "", points: 2 };
			const officialAccount = i.linkValue.officialAccount || { accountTitle: "", accountUrl: "" };
			const shareImage = i.linkValue?.shareImage || "";
			const shareInfo = i.linkValue?.shareInfo || "";
			let productSort = 0;
			if (this.mode === 2) {
				if (i.linkType === 9) {
					productSort = i.linkValue?.productSort === null ? null : i.linkValue?.productSort || 1;
				} else {
					productSort = i.linkValue?.productSort || 1;
				}
			}

			return {
				linkId: i.linkValue.linkId,
				linkType: i.linkValue.linkType,
				linkDesc: i.linkValue.linkDesc,
				hotPosition: {
					x: i.linkValue.hotPosition.x,
					y: i.linkValue.hotPosition.y,
					height: i.linkValue.hotPosition.height || 50,
					width: i.linkValue.hotPosition.width || 50,
					xPercent: (i.linkValue.hotPosition.x / 375).toFixed(2),
					yPercent: (i.linkValue.hotPosition.y / this.targetHeight).toFixed(2),
					hPercent: ((i.linkValue.hotPosition.height || 50) / this.targetHeight).toFixed(2),
					wPercent: ((i.linkValue.hotPosition.width || 50) / 375).toFixed(2),
				},
				couponInfo,
				jumpPath,
				officialAccount,
				productSort,
				shareImage,
				shareInfo,
			};
		});
		return result;
	}

	onLinkComChange(val) {
		this.selectType = val.linkType;
		this.linkId = val.linkId;
	}

	addHot() {
		const item = cloneDeep(this.newHotItem);
		item["linkValue"] = cloneDeep(this.newHotItem);
		this.sort += 1;
		item["ref"] = `hot${this.sort}`;
		this.hotArray.push(item);
	}

	deleteItem(index) {
		this.$confirm("此操作将删除该热区, 是否继续?", "提示", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			type: "warning",
		}).then((result) => {
			if (result === "confirm") {
				this.hotArray.splice(index, 1);
				this.hotActiveIndex = this.hotArray.findIndex((v) => v.__active);
			}
		}, noop);
	}

	onHotItemClick(item, index) {
		this.hotArray = this.hotArray.map((v: any, i) => {
			v._active = i === index;
			return v;
		});
		this.hotActiveIndex = index;
	}

	cancelClick(index) {
		this.hotArray = this.hotArray.map((v: any) => {
			v._active = false;
			return v;
		});
		this.hotActiveIndex = index;
	}

	beforeConfirm() {
		const index = this.hotArray.findIndex((v) => v.linkValue.linkType === 12 && (!v.linkValue.couponInfo.couponCover || !Number(v.linkValue.couponInfo.points > 0)));
		if (index != -1) {
			this.hotActiveIndex = index;
			this.hotArray.map((v, i) => {
				v._active = i === index;
				return v;
			});
			this.$nextTick(() => {
				this.$refs.linkForm.$refs.form.validate(noop);
			});
			this.confirmloading = false;
		} else {
			this.$emit("result", this.results());
			this.$emit("hidden");
		}
	}

	getLinkText(linkType) {
		let result = "";
		switch (linkType) {
			case 3:
				result = "商品分类";
				break;
			case 13:
				result = "小程序";
				break;
			default:
				break;
		}
		return result;
	}

	/**
	 * 获取关联分类
	 */
	getAttributeList(): Promise<any> {
		return IPSService.getAttributeList().then((res) => {
			return isset(res, "list") ? res.list : [];
		});
	}

	renderContent(h) {
		return (
			<div class="add-hot-dialog">
				<div class="left">
					<div class="hot-wrap">
						<el-image class="upLoadedPic relative wid-188 no-border no-scroll" onLoad={this.onLoad.bind(this)} src={this.img} />
						{this.targetHeight
							? this.hotArray.map((v, i) => {
									return (
										<VueDraggableResizable
											ref={v.ref}
											key={`${i}hot`}
											class="hot"
											minw={50}
											minh={50}
											x={v.hotPosition.x}
											y={v.hotPosition.y}
											w={v.hotPosition.width}
											h={v.hotPosition.height}
											on-dragstop={(x, y) => this.onDrag(x, y, i)}
											on-resizestop={(x, y, w, h) => this.onResize(x, y, w, h, i)}
											on-activated={this.onHotItemClick.bind(this, v, i)}
											onDeactivated={this.cancelClick.bind(this, i)}
											parent={true}
											handles={["tl", "tm", "mr", "br", "bm", "bl", "ml"]}>
											<p class="link">
												{v.linkValue.linkType === 3 || v.linkValue.linkType === 13 ? <span class="text">{this.getLinkText(v.linkValue.linkType)}</span> : <span class="text">{v.linkValue.linkDesc ? v.linkValue.linkDesc : "点击设置关联链接"}</span>}
											</p>
											{this.getDisabledClose(i) && v._active && <i class="close el-icon-close" onClick={this.deleteItem.bind(this, i)} />}
										</VueDraggableResizable>
									);
							  })
							: ""}
					</div>
					{this.state == 1 ? (
						<el-button class="bottom-btn" type="primary" onClick={this.addHot.bind(this)}>
							添加热区
						</el-button>
					) : (
						""
					)}
				</div>

				<div class="right">
					{this.hotActiveIndex > -1 && (
						<LinkForm
							v-model={this.hotArray[this.hotActiveIndex].linkValue}
							onChange={this.onLinkComChange.bind(this)}
							state={this.form.advId && this.hotArray[this.hotActiveIndex].linkValue.linkType === 12 ? 3 : this.state}
							siteCodes={this.form.siteCodes}
							sgId={this.form.sgId}
							empCode={this.empCode}
							attributeList={this.attributeList}
							ref="linkForm"
							linkText=""
							siteId={this.siteId}
							exclude={this.exclude}
							mode={this.mode}
							sortShow={+this.mode === 2 ? true : false}
							dialogFooter={+this.mode === 2 ? false : true}
							hotarea={true}
							class="hot-ad-link"
							hotAd={false}></LinkForm>
					)}
				</div>
			</div>
		);
	}
}
